export default __webpack_public_path__ + "static/media/wazirabad.9b568568.jpg";